import { useQuery } from "@tanstack/react-query";
import axiosInstance from "@/lib/axios";
import { doc_endpoint } from "@/config/endpoints";

export type BrochureDoc = {
  id: number;
  fileName: string;
  fileUrl: string;
  s3Key: string;
  type: string;
  size: number;
  category: string;
  attachedTo: string;
  attachedScope: number;
  name?: string | null;
};

export const courseBrochureQueryKey = (
  courseId: number | null | undefined
) => ["course-brochure", courseId] as const;

export default function useCourseBrochure(courseId: number | null | undefined) {
  const query = useQuery({
    queryKey: courseBrochureQueryKey(courseId),
    enabled: Boolean(courseId),
    queryFn: async (): Promise<BrochureDoc | null> => {
      if (!courseId) return null;
      const res = await axiosInstance.get(doc_endpoint, {
        params: {
          attachedTo: "course",
          attachedScope: courseId,
          limit: 50,
        },
      });
      const docs: BrochureDoc[] = res.data?.data ?? [];
      const brochure =
        docs.find((d) => (d.category || "").toLowerCase() === "brochure") ??
        docs[0] ??
        null;
      return brochure;
    },
  });

  return {
    brochure: query.data ?? null,
    isLoading: query.isLoading,
    refetch: query.refetch,
  };
}
